import { OfficeRoutePath } from '@/RoutePath'

/** Office routes that ship Hebrew + English UI copy and should show the language switcher. */
const OFFICE_TRANSLATED_ROUTES = [
  OfficeRoutePath.FinanceMicro,
  OfficeRoutePath.FinanceMacro,
  OfficeRoutePath.FinanceSettings,
  OfficeRoutePath.Affiliate,
  OfficeRoutePath.Coupon,
  OfficeRoutePath.MarketingDashboard,
  OfficeRoutePath.MarketingCampaigns,
  OfficeRoutePath.MarketingInvoices,
  OfficeRoutePath.MarketingAffiliatePackages,
  OfficeRoutePath.MarketingEmails,
  OfficeRoutePath.PkgLookup,
  OfficeRoutePath.PkgCases,
] as const

export function isOfficeTranslatedPath(pathname: string): boolean {
  return OFFICE_TRANSLATED_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`))
}
